import { type TableSortOrder } from '@/components/Table'
import { type Team } from '@/features/iam/teams/Team'
import { computed, action, observable } from 'mobx'
import { orderBy } from 'lodash-es'
import { type PendingTeamMember } from '@/features/iam/teams/PendingTeamMember'

export type PendingMembersTableColumnKey = 'email' | 'dateCreated' | 'expires'

export class PendingTeamMembersViewModel {
  @observable accessor sortOrder: TableSortOrder = 'none'
  @observable accessor sortField: PendingMembersTableColumnKey = 'email'

  constructor(
    public readonly team: Team,
    private readonly _getPendingMembers: () => PendingTeamMember[],
    private readonly _getSearchText: () => string,
  ) {}

  @computed
  get pendingTeamMembers() {
    return this._getPendingMembers()
  }

  @computed
  get searchText() {
    return this._getSearchText()
  }

  @computed
  get filtered() {
    let pendingMembers = this.pendingTeamMembers

    if (this.searchText !== '') {
      pendingMembers = this.pendingTeamMembers.filter((pendingMember) =>
        pendingMember.email
          .toLowerCase()
          .includes(this.searchText.toLowerCase()),
      )
    }

    return orderBy(
      pendingMembers,
      [this.sortField],
      this.sortOrder === 'none' ? undefined : this.sortOrder,
    )
  }

  @action.bound
  setSort(sortField: PendingMembersTableColumnKey, sortOrder: TableSortOrder) {
    this.sortField = sortField
    this.sortOrder = sortOrder
  }
}
